<template>
  <div class="support-project">
    <div class="head">
      <i class="iconfont icon--projects el-button--text"></i>{{item.name_cn}}
      <p class="operation pull-right">
        <template v-if="editing">
          <el-button type="text" @click="linkTo(item.name)">+ 添加新成果</el-button>
          <!-- 排序操作 -->
          <el-dropdown @command="handleSortCommand" :trigger="isMobile ? 'click' : 'hover'">
            <span class="el-dropdown-link el-button--text">
              {{text}}<i class="el-icon-caret-bottom el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="timeAsc">按获得时间升序</el-dropdown-item>
              <el-dropdown-item command="timeDesc">按获得时间降序</el-dropdown-item>
              <el-dropdown-item divided command="weightDesc">按重要程度降序</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <el-dropdown @command="handleCommand" :trigger="isMobile ? 'click' : 'hover'">
            <span class="el-dropdown-link el-button--text">
              <i class="iconfont icon--menu-dot"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="hideModule">隐藏模块</el-dropdown-item>
              <el-dropdown-item command="sortModule">模块排序</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </p>
    </div>
    <div class="detail">
      <div class="text">
        <!-- 默认显示10条 -->
        <ul>
          <template v-for="(item, sub) in (editing ? item.data : item.data.filter(n => parseInt(n.display_status) !== 0))">
            <template v-if="sub < 10">
              <li :class="{'status-hide' : item.display_status == 0}" :key="sub">
                <template v-if="editing">
                  <span v-if="item.display_status == 1" class="status status-show" @click="updateItem(index, sub, 0)">

                    <template v-if="isMobile">
                      <i class="iconfont icon--show"></i>
                    </template>
                    <template v-else>
                      <el-tooltip class="item" effect="dark" content="点此隐藏此成果" placement="left">
                        <i class="iconfont icon--show"></i>
                      </el-tooltip>
                    </template>
                  </span>

                  <template v-else>
                    <template v-if="isMobile">
                      <span class="status status-hide" @click="updateItem(index, sub, 1)">
                        已隐藏<i class="iconfont icon--hide"></i>
                      </span>
                    </template>
                    <template v-else>
                      <el-tooltip class="item" effect="dark" content="点此显示此成果" placement="left">
                        <span class="status status-hide" @click="updateItem(index, sub, 1)">
                          已隐藏<i class="iconfont icon--hide"></i>
                        </span>
                      </el-tooltip>
                    </template>
                  </template>
                </template>
                <!-- 序号 -->
                <span class="serial-number">[{{sub + 1}}]</span>
                <!-- 主持项目 -->
                <span>{{item.govresearch.source}},</span>
                <!-- 项目名称 -->
                <span>{{item.title}},</span>
                <!-- 起止年份 -->
                <span>{{item.govresearch.puttime.split('-')[0]}}-{{item.govresearch.endtime.split('-')[0]}}</span>
                <!-- 状态 -->
                <span>{{item.govresearch.kc_status}},</span>
                <!-- 身份 -->
                <span>{{item.govresearch.rank}}.</span>
              </li>
            </template>
          </template>
        </ul>
        <!-- 大于10条的部分 -->
        <ul v-show="showMore">
          <template v-for="(item, sub) in (editing ? item.data : item.data.filter(n => parseInt(n.display_status) !== 0))">
            <template v-if="sub > 9">
              <li :class="{'status-hide' : item.display_status == 0}" :key="sub">
                <template v-if="editing">
                  <span v-if="item.display_status == 1" class="status status-show" @click="updateItem(index, sub, 0)">

                    <template v-if="isMobile">
                      <i class="iconfont icon--show"></i>
                    </template>
                    <template v-else>
                      <el-tooltip class="item" effect="dark" content="点此隐藏此成果" placement="left">
                        <i class="iconfont icon--show"></i>
                      </el-tooltip>
                    </template>
                  </span>

                  <template v-else>
                    <template v-if="isMobile">
                      <span class="status status-hide" @click="updateItem(index, sub, 1)">
                        已隐藏<i class="iconfont icon--hide"></i>
                      </span>
                    </template>
                    <template v-else>
                      <el-tooltip class="item" effect="dark" content="点此显示此成果" placement="left">
                        <span class="status status-hide" @click="updateItem(index, sub, 1)">
                          已隐藏<i class="iconfont icon--hide"></i>
                        </span>
                      </el-tooltip>
                    </template>
                  </template>
                </template>
                <!-- 序号 -->
                <span class="serial-number">[{{sub + 1}}]</span>
                <!-- 主持项目 -->
                <span>{{item.govresearch.source}},</span>
                <!-- 项目名称 -->
                <span>{{item.title}},</span>
                <!-- 起止年份 -->
                <span>{{item.govresearch.puttime.split('-')[0]}}-{{item.govresearch.endtime.split('-')[0]}}</span>
                <!-- 状态 -->
                <span>{{item.govresearch.kc_status}},</span>
                <!-- 身份 -->
                <span>{{item.govresearch.rank}}.</span>
              </li>
            </template>
          </template>
        </ul>
        <div class="show-more" v-if="!showMore && (editing ? item.data : item.data.filter(n => parseInt(n.display_status) !== 0)).length >= 10 && hasMore">
          <el-button :loading="loading" type="text" @click="showMoreItem">查看更多成果<i class="iconfont icon--arrow"></i></el-button>
        </div>
        <div class="hide-more" v-if="showMore && (editing ? item.data : item.data.filter(n => parseInt(n.display_status) !== 0)).length > 10 && hasMore">
          <el-button type="text" @click="hideMoreItem">收起<i class="iconfont icon--arrow-up"></i></el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DocsMixins from './docsMixins'

export default {
  mixins: [DocsMixins]
}
</script>



// WEBPACK FOOTER //
// src/pages/Index/projects.vue